import { allowAdminPreview } from './preview/preview-safety';

function showLoadFailure(error: unknown) {
  console.error('Unable to load Molaris Admin', error);
  const root = document.getElementById('root');
  if (root) {
    root.setAttribute('role', 'alert');
    root.textContent = 'Molaris Admin could not load. Reload the page to try again.';
  }
}

// Vite removes the fixture import from normal builds. No real auth/client
// module is initialized on this branch, including on a rejected preview host.
if (import.meta.env.DEV && import.meta.env.MODE === 'admin-preview') {
  if (!allowAdminPreview(true, import.meta.env.MODE, window.location.hostname)) {
    showLoadFailure(new Error('Admin preview requires a loopback development server.'));
  } else {
    void import('./preview/preview-entry').catch(showLoadFailure);
  }
} else {
  void import('./production-entry').catch(showLoadFailure);
}
